// extracted by mini-css-extract-plugin
export default {"FooterPaymentElement":"FooterPaymentElement_FooterPaymentElement__V2MZY"};